// extracted by css-extract-rspack-plugin
module.exports =  {"root":"BundleManager__root___RiQRL","bundleViewer":"BundleManager__bundleViewer___OFzfZ"};